import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import ReactInk from "react-ink";
export const Ink = (props) => {
    if (process.env.NODE_ENV === "test") {
        // Skip rendering canvas elements in tests
        return _jsx(_Fragment, {});
    }
    return _jsx(ReactInk, { ...props });
};
